module.exports = __webpack_public_path__ + "img/2025_MRC_Symposium_SG.f4bf2385.jpeg";